import { useState } from "react";

import Modal from "ui-components/Modal";

import { useFetchDataFile } from "modules/data-files/api";
import { SelectSingleData } from "modules/data-files/elements/Data-File-Select";
import UploadFiles from "modules/data-files/elements/upload-files";

import { usePerfFile, useSiteFile } from "./store";

const SelectData = () => {
  const [showFileUpload, setShowFileUpload] = useState(false);

  const [perfFile, setPerfFile] = usePerfFile();
  useFetchDataFile(perfFile, true);

  const [siteFile, setSiteFile] = useSiteFile();
  useFetchDataFile(siteFile, true);

  return (
    <>
      <SelectSingleData
        label={
          <div>
            <p>Select Performance Data:</p>
            <p className="font-normal text-sm text-gray-700">
              Cant find the data you want to select?{" "}
              <a
                className="underline text-primary-main cursor-pointer"
                onClick={() => setShowFileUpload(true)}
              >
                Click here to upload.
              </a>
            </p>
          </div>
        }
        selected={perfFile}
        onChange={setPerfFile}
        name="select-perf-data"
        enableTypeSelection
        enableDrop
      />
      <SelectSingleData
        label={
          <div>
            <p>Select Site Data:</p>
            <p className="font-normal text-sm text-gray-700">
              Cant find the data you want to select?{" "}
              <a
                className="underline text-primary-main cursor-pointer"
                onClick={() => setShowFileUpload(true)}
              >
                Click here to upload.
              </a>
            </p>
          </div>
        }
        selected={siteFile}
        onChange={setSiteFile}
        name="select-site-data"
        enableTypeSelection
        enableDrop
      />
      <Modal
        show={showFileUpload}
        id="upload-files"
        handleClose={() => setShowFileUpload(false)}
      >
        <div className="m-2 p-2">
          <UploadFiles onComplete={() => setShowFileUpload(false)} />
        </div>
      </Modal>
    </>
  );
};

export default SelectData;
